module.exports = __webpack_public_path__ + "img/person-from-portal.2221af17.svg";